var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8RfidSensor50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M24,16c-4.398,0-8,3.602-8,8s3.602,8,8,8s8-3.602,8-8S28.398,16,24,16z M24,30c-3.301,0-6-2.699-6-6s2.699-6,6-6s6,2.699,6,6S27.301,30,24,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M24,10c-7.753,0-14,6.247-14,14s6.247,14,14,14s14-6.247,14-14S31.753,10,24,10z M24,36c-6.656,0-12-5.344-12-12s5.344-12,12-12s12,5.344,12,12S30.656,36,24,36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3e5fc",
    d: "M24,4C13.002,4,4,13.002,4,24s9.002,20,20,20s20-9.002,20-20S34.998,4,24,4z M24,42c-9.901,0-18-8.099-18-18S14.099,6,24,6s18,8.099,18,18S33.901,42,24,42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M26,24c0,1.104-0.896,2-2,2s-2-0.896-2-2s0.896-2,2-2S26,22.896,26,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M42,25H30l-5,5v12c0,1.102,0.898,2,2,2h15c1.102,0,2-0.898,2-2V27C44,25.898,43.102,25,42,25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5d6a7",
    d: "M38,39h-7c-0.602,0-1-0.398-1-1v-7c0-0.602,0.398-1,1-1h7c0.602,0,1,0.398,1,1v7C39,38.602,38.602,39,38,39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RfidSensor50);
export default __webpack_public_path__ + "static/media/icons8-rfid-sensor-50.8c0c27012853e795f3235f10120c4f4f.svg";
export { ForwardRef as ReactComponent };